import styled, { css } from "styled-components";
import themeIcon from "../../../assets/images/buttonIcons/theme-icon.svg";
import { hideOnMedia } from "../../styles/responsive/responsiveUtils";

export const StyledToggler = styled.button`
    ${({ disabled }) => disabled &&
            css`
          opacity: 0.6;
          cursor: default;
        `
    }
    
  .theme-icon {
    width: 11px !important;
    background: url(${themeIcon}) ${({ theme }) => theme.switchTheme} no-repeat;
    background-size: 25px 11px;
  }

  .text {
    ${hideOnMedia('xm')}
  }
`;

